'use client';

import {
  ActionIcon,
  Box,
  Button,
  Image,
  Stack,
  Text,
  Title,
  rem,
  useMantineColorScheme,
} from '@mantine/core';
import { closeModal, type ContextModalProps } from '@mantine/modals';
import { X } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { ModalName } from '..';
import { ListDetailCod } from './list-detail-cod';
import styles from './modal-max-code-styles.module.css';
import { assetPrefix } from '@/lib/constants';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';
import { useDetectModalStore } from '@/stores';

const ModalMaxCodInfoDetail = ({ id }: ContextModalProps) => {
  const { colorScheme } = useMantineColorScheme();
  const tBooking = useTranslations('booking');

  const setDetectModalId = useDetectModalStore.use.setDetectModalId();
  const clearDetectModalId = useDetectModalStore.use.clearDetectModalId();

  const isMobile = useIsMobile();

  useEffect(() => {
    setDetectModalId(id);
    return () => clearDetectModalId();
  }, [clearDetectModalId, id, setDetectModalId]);

  return (
    <>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0,
          justifyContent: isMobile ? 'flex-start' : 'space-between',
          flex: '1 1 auto',
          backgroundColor: '#fff',
        }}
      >
        <Box className={styles.imagePromotionDetail}>
          <Image
            src={`${assetPrefix}/static/images/cod/cod-thumbnail.webp`}
            alt="thumbnail-cod-limit-service"
            fit="cover"
            loading="lazy"
            onError={() => {
              return `${assetPrefix}/static/images/cod/cod-thumbnail.webp`;
            }}
          />
        </Box>
        <ActionIcon
          variant="light"
          size={40}
          style={{
            borderRadius: '50%',
            position: 'absolute',
            top: 16,
            right: 16,
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
          }}
          onClick={() => {
            closeModal(ModalName.DetailMaxCod);
            clearDetectModalId;
          }}
        >
          <X
            size={24}
            color={
              colorScheme === 'dark'
                ? 'var(--mantine-color-neutral-2)'
                : 'var(--mantine-color-neutral-6)'
            }
          />
        </ActionIcon>
        <Stack p={20} gap={0}>
          <Title order={5}>
            {tBooking('location.modal_learn_about_cod_title')}
          </Title>
          <Text>{tBooking('location.modal_learn_about_cod_description')}</Text>
          <ListDetailCod pt={16} mx={-20} />
          <Box
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              mih={rem(48)}
              size="md"
              mt={24}
              onClick={() => {
                closeModal(ModalName.DetailMaxCod);
              }}
              styles={{
                root: {
                  width: 'fit-content',
                },
              }}
            >
              {tBooking('location.modal_learn_about_cod_btn_got_it')}
            </Button>
          </Box>
        </Stack>
      </Box>
    </>
  );
};
export default ModalMaxCodInfoDetail;
